import React, {Component} from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Collapse,
    Typography,
    Box,
    withStyles
} from '@material-ui/core';

const styles = theme => ({
    sectionCard: {
        border: `1px solid #DDDDDD`,
        borderRadius: 8,
        marginBottom: "1rem",
        backgroundColor: '#FFFFFF',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        overflow: 'hidden'
    },
    sectionHeader: {
        cursor: 'pointer',
        padding: '0.75rem 1rem',
        backgroundColor: '#F1F3F5',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:hover': {
            backgroundColor: '#E9ECEF',
        },
    },
    cardTitleContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    cardTitle: {
        fontWeight: 500,
        fontSize: '1rem',
        color: '#212529',
    },
});

class CardSection extends Component {
    render() {
        const {
            classes,
            title,
            icon,
            expanded = false,
            onToggle,
            children
        } = this.props;

        return (
            <Card className={classes.sectionCard}>
                <CardHeader
                    title={
                        <Box className={classes.cardTitleContainer}>
                            {icon && React.cloneElement(icon, { style: { marginRight: 8 } })}
                            <Typography className={classes.cardTitle}>{title}</Typography>
                            <Typography className={classes.cardTitle}>
                                {expanded ? <>▲</> : <>▼</>}
                            </Typography>
                        </Box>
                    }
                    className={classes.sectionHeader}
                    onClick={onToggle}
                />
                <Collapse in={expanded}>
                    <CardContent style={{ padding: 0 }}>
                        {children}
                    </CardContent>
                </Collapse>
            </Card>
        );
    }
}

export default withStyles(styles)(CardSection);
